import apiService from './apiService'

/**
 * Alert Service - Handles API calls for alerts/échéances
 */

/**
 * Get all alerts with optional filters
 * @param {Object} params - Filter parameters
 * @returns {Promise} API response
 */
export async function getAlertes(params = {}) {
  try {
    const queryParams = new URLSearchParams(params).toString()
    const endpoint = `/alertes${queryParams ? `?${queryParams}` : ''}`
    const response = await apiService.get(endpoint)
    return response
  } catch (error) {
    console.error('Error fetching alerts:', error)
    throw error
  }
}

/**
 * Get pending alerts (en attente de règlement)
 * @returns {Promise} API response
 */
export async function getAlertesEnAttente() {
  try {
    const response = await apiService.get('/alertes/en-attente')
    return response
  } catch (error) {
    console.error('Error fetching pending alerts:', error)
    throw error
  }
}

/**
 * Get paid alerts (factures réglées)
 * @returns {Promise} API response
 */
export async function getAlertesReglees() {
  try {
    const response = await apiService.get('/alertes/reglees')
    return response
  } catch (error) {
    console.error('Error fetching paid alerts:', error)
    throw error
  }
}

/**
 * Get specific alert by ID
 * @param {number} id - Alert ID
 * @returns {Promise} API response
 */
export async function getAlerteById(id) {
  try {
    const response = await apiService.get(`/alertes/${id}`)
    return response
  } catch (error) {
    console.error('Error fetching alert by ID:', error)
    throw error
  }
}

/**
 * Create new alert
 * @param {Object} alertData - Alert data
 * @returns {Promise} API response
 */
export async function createAlerte(alertData) {
  try {
    const response = await apiService.post('/alertes', alertData)
    return response
  } catch (error) {
    console.error('Error creating alert:', error)
    throw error
  }
}

/**
 * Update alert
 * @param {number} id - Alert ID
 * @param {Object} alertData - Updated alert data
 * @returns {Promise} API response
 */
export async function updateAlerte(id, alertData) {
  try {
    const response = await apiService.put(`/alertes/${id}`, alertData)
    return response
  } catch (error) {
    console.error('Error updating alert:', error)
    throw error
  }
}

/**
 * Delete alert
 * @param {number} id - Alert ID
 * @returns {Promise} API response
 */
export async function deleteAlerte(id) {
  try {
    const response = await apiService.delete(`/alertes/${id}`)
    return response
  } catch (error) {
    console.error('Error deleting alert:', error)
    throw error
  }
}

/**
 * Generate next payment alert
 * @param {number} contractId - Contract ID
 * @param {number} paidInvoiceId - Paid invoice ID (optional)
 * @returns {Promise} API response
 */
export async function generateNextPaymentAlert(contractId, paidInvoiceId = null) {
  try {
    const url = paidInvoiceId 
      ? `/alertes/generate-next/${contractId}/${paidInvoiceId}`
      : `/alertes/generate-next/${contractId}`
    
    const response = await apiService.post(url)
    return response.data
  } catch (error) {
    console.error('Error generating next payment alert:', error)
    throw error
  }
}

export default {
  getAlertes,
  getAlertesEnAttente,
  getAlertesReglees,
  getAlerteById,
  createAlerte,
  updateAlerte,
  deleteAlerte,
  generateNextPaymentAlert
}